import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TopMenuTitleService {
  // Kept after hide() so the top menu can fade it out.
  private readonly titleState = signal('');
  private readonly visibleState = signal(false);
  private owner: object | null = null;

  public readonly title = this.titleState.asReadonly();
  public readonly visible = this.visibleState.asReadonly();

  public show(owner: object, title: string): void {
    this.owner = owner;
    this.titleState.set(title);
    this.visibleState.set(true);
  }

  public hide(owner: object): void {
    if (this.owner !== owner) {
      return;
    }
    this.owner = null;
    this.visibleState.set(false);
  }
}
